module.exports = __webpack_public_path__ + "img/dasboard_chart_plug.468b84da.svg";